angular.module('impactx.basket').controller('BasketApproverCtrl', ['$scope', BasketApproverCtrl]);

function BasketApproverCtrl($scope) {
    $scope.showDialog = false;
    $scope.$watch("approver", function() {
        $scope.secondApprovalStep = $scope.approver.setEntriesStep2.length > 0;
    });

    $(document).on('click', function(event) {
        if($(event.target).closest('.selection-dialog-approval').length === 0 &&
            $(event.target).closest('#' + $scope.selectionId).length === 0) {
            $scope.showDialog = false;
            $scope.$evalAsync();
        }
    });

    $scope.hasImageURL = function(item) {
        return item.imageUrl != undefined;
    };

    $scope.changeApprovalStep = function() {
        $scope.approver.setEntriesStep2 = [];
        $scope.toggleDialog();
        if($scope.approver.setEntries.length > 0) {
            $scope.secondApprovalStep = !$scope.secondApprovalStep;
        }
    };

    $scope.toggleDialog = function() {
        $scope.showDialog = !$scope.showDialog;
    };

    $scope.addApprover = function(item) {
        var alreadyInserted = false;
        $scope.resultEntries.forEach(function(entry) {
            if(entry.id == item.id) alreadyInserted = true;
        });
        if(item && !alreadyInserted) $scope.resultEntries.push(item);
        $scope.toggleDialog();
    };

    // todo: do this more generic for further approval steps
    $scope.deleteApproverFromStep1 = function(item) {
        var tmpArray = [];
        $scope.approver.setEntries.forEach(function(entry) {
            if(entry != item) tmpArray.push(entry);
        });
        $scope.approver.setEntries = tmpArray;

        if($scope.approver.setEntries.length == 0) {
            $scope.approver.setEntriesStep2 = [];
            $scope.secondApprovalStep = false;
        }
    };

    // todo: do this more generic for further approval steps
    $scope.deleteApproverFromStep2 = function(item) {
        var tmpArray = [];
        $scope.approver.setEntriesStep2.forEach(function(entry) {
            if(entry != item) tmpArray.push(entry);
        });
        $scope.approver.setEntriesStep2 = tmpArray;
    };

    $scope.getSelectableApprover = function(approver, resultEntries) {
        approver = approver.filter(function(el) {
            return resultEntries.indexOf(el) < 0;
        });
        return approver;
    };
}